import React, { useState, useReducer, useEffect, useRef } from "react";
import { Button, Grid, Modal, Icon, Popup, Checkbox } from "semantic-ui-react";
import {
  initialState,
  reducer,
  ACTION,
} from "../../../Reducer/InitialStateReducer";

import { server } from "../../../App";
import axios from "axios";

import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
// import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import {
  columnDefsConsultation,
  defaultColDefConsultation,
} from "./GridParamsCourrier/GridParams";
import moment from "moment";
import "moment/locale/fr";
import { toast } from "react-toastify";

import { Editor } from "@tinymce/tinymce-react";

import { useSelector, useDispatch } from "react-redux";
import { selectCounters, Courrier_Counter_Reducer } from "../../../features/counter/counterSlice";


// Create styles

function Medicaments(props) {
  const dispatchRedux = useDispatch();
  const CountersState = useSelector(selectCounters);
  const [state, dispatch] = useReducer(reducer, initialState);

  const [, setGridApi] = useState(null);
  const [, setGridColumnApi] = useState(null);
  const [ami, setAmi] = useState(false);
  const [checked, setChecked] = useState(false);
  const handleClick = () => setChecked(!checked);
  const handleClickAmi = () => setAmi(!ami);

  const {
    ID,
    syncData,
    userInformation,

    questionnaireData,
    consultationData,
    AuthState,
  } = props;

  let Courrier_Ant_Rows, Courrier_Consul_Rows;
  Courrier_Ant_Rows = state.Courrier_Ant_Rows;
  Courrier_Consul_Rows = state.Courrier_Consul_Rows;

  moment.locale("fr");
  // let date_courrier = moment().format("DD/MM/YYYY")
  let date_courrier_Long = moment().format("dddd D MMMM YYYY");
  const objectToSend = {
    Courrier_Ant_Rows,
    Courrier_Consul_Rows,
  };

  const columnDefs2 = [
    // {
    //     headerName: "Numero",
    //     field: "Numero",
    //     valueGetter: "node.rowIndex + 1",
    //     // hide: true,
    //     // width: 90,
    //     // suppressSizeToFit: false,
    //     // checkboxSelection: true,
    //     // minWidth: 90,
    //     // maxWidth: 90,
    // },
    {
      headerName: "Categorie",
      field: "categorie",
      editable: false,
      // hide: true,
      checkboxSelection: true,
    },
    {
      headerName: "Antécédent",
      field: "nom",
    },
    {
      headerName: " ",
      field: "commentaire",
      // checkboxSelection: true,
    },
    {
      headerName: " ",
      field: "commentaire2",
      // checkboxSelection: true,
    },

    // 1ere sous catégorie
  ];

  const defaultColDef2 = {
    suppressMovable: true,
    // sortable: true,
    editable: true,
    cellEditor: "agLargeTextCellEditor",
    // maxLength: 2550,
    cellEditorParams: {
      maxLength: "1000",
      cols: "60",
      rows: "2",
    },
    flex: 1,
    // filter stuff
    filter: true,
    // floatingFilter: true,
    // suppressMenu: true,
    // end of filter stuff
    minWidth: 100,
    // resizable: true,
    // tooltipComponent: 'customTooltip',
    filterParams: {
      newRowsAction: "keep",
      // buttons: ['apply', 'clear'],
    },
    resizable: true,
    cellClass: "cell-wrap-text",
    autoHeight: true,
  };

  useEffect(() => {
    // getOneUser()
    dispatch({ type: ACTION.FETCH_SUCCESS2, payload: questionnaireData });
    dispatch({ type: ACTION.FETCH_SUCCESS, payload: consultationData });
  }, [state.open]);

  const writeToConsultation = async () => {
    let variable = date_courrier_Long ? `Le ${date_courrier_Long}` : "";

    let valueToPost = `Courrier fait ${variable}`;

    const ValuesToCreate = {
      fk_id_patientConsul: ID,
      created_by: AuthState.user_name,
      od: valueToPost,
      fk_id_examen: 1,
      observation: "-",
    };

    axios({
      method: "post",
      responseType: "json",
      url: `${server}Consultation`,
      data: ValuesToCreate,
      headers: {
        jwtoken: sessionStorage.token,
      },
    })
      .then((response) => {
        syncData(response.data);
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: ACTION.CREATE_ERROR });
      });
  };

  const editorRef = useRef(null);

  const onValueChanged = async () => {
    if (editorRef.current) {
      // console.log(editorRef.current.getContent());

      const ValuesToCreate = {
        fk_id_patientConsul: ID,
        description: editorRef.current.getContent(),
      };
      axios({
        method: "post",
        responseType: "json",
        url: `${server}Consultation/addArticle`,
        data: ValuesToCreate,
        headers: {
          jwtoken: sessionStorage.token,
        },
      })
        .then((response) => {
          dispatchRedux(Courrier_Counter_Reducer(CountersState.Courrier_Counter + 1));
          writeToConsultation();
          toast.success("Success", {
            position: toast.POSITION.TOP_LEFT,
          });
          dispatch({ type: ACTION.CLOSE });
        })
        .catch((err) => {
          console.log(err);
          dispatch({ type: ACTION.CREATE_ERROR });
        });
    }
  };

  const onGridReady = (params) => {
    setGridColumnApi(params.columnApi);
    setGridApi(params.api);
  };

  const onSelectionChanged2 = (e) => {
    if (e.api.getSelectedRows()[0] === undefined) {
      const emptyCheckbox = [];
      dispatch({
        type: ACTION.COURRIER_ANT,
        value: emptyCheckbox,
      });
    } else {
      let clientArray = e.api.getSelectedRows();

      dispatch({
        type: ACTION.COURRIER_ANT,
        value: clientArray,
      });
    }
  };
  const onSelectionChangedConsul = (e) => {
    if (e.api.getSelectedRows()[0] === undefined) {
      const emptyCheckbox = [];
      dispatch({
        type: ACTION.COURRIER_CONSUL,
        value: emptyCheckbox,
      });
    } else {
      let clientArray = e.api.getSelectedRows();

      dispatch({
        type: ACTION.COURRIER_CONSUL,
        value: clientArray,
      });
    }
  };

  const onCellValueChangedConsul = async (e) => {
    let clientArray = e.api.getSelectedRows();

    dispatch({
      type: ACTION.COURRIER_CONSUL,
      value: clientArray,
    });
  };
  const onCellValueChanged2 = async (e) => {
    let clientArray = e.api.getSelectedRows();

    dispatch({
      type: ACTION.COURRIER_ANT,
      value: clientArray,
    });
  };
  // ///////////////////////////////////////////////////////////////////////////////

  let contentHtml, contentHtml2;
  contentHtml2 = "";
  contentHtml = "";

  contentHtml = objectToSend?.Courrier_Ant_Rows?.map(
    (item, i) =>
      ` ${item?.nom}   ${item?.commentaire} ${item?.commentaire2}, `
  );
  contentHtml2 = objectToSend?.Courrier_Consul_Rows?.map(
    (item, i) => `<div style="display:flex;padding-left: 30px;">${item?.nom_examen} :  ${item?.og ? `OG : ${item?.og}` : ""}  ${item?.nom_examen === "Note" ? ` ${item?.od}` : item?.nom_examen === "Motif Cs" ? ` ${item?.od}` : item?.od ? `OD : ${item?.od}  ` : ""} ${item?.observation ? `${item?.observation}` : ""}</div>`);

  let dataToSee = "";
  if ((contentHtml2 && contentHtml?.length === 0) || (contentHtml === undefined && contentHtml2)) {
    dataToSee = contentHtml2?.join(" ").toString();
  } else if (!contentHtml2 && contentHtml?.length > 0) {
    dataToSee = `<p style="text-align: justify;">Antécédents : ${contentHtml?.join(" ").toString()}</p>`;
  } else if (contentHtml2 && contentHtml?.length > 0) {
    dataToSee =
      `<p style="text-align: justify;">Antécédents : ${contentHtml?.join(" ").toString()}</p>` +

      contentHtml2?.join(" ").toString();
  }

  // console.log({ contentHtml2, contentHtml })
  // console.log(contentHtml?.join(" ").toString());
  // console.log({ userInformation, option, date_courrier_Long });

  // let contentHtml3 = `<h2 style="text-align: center;">${userInformation?.civilite} ${userInformation?.nom} ${userInformation?.prenom}</h2>`;
  let contentHtml3 = `<div>${!ami ? "Cher Confrère(e)," : "Cher Ami(e),"
    }</div>`;

  let contentHtml5 = "";

  if (checked) {
    contentHtml5 = ` <div>
        Je te remercie de m'avoir adressé ${userInformation?.civilite} 
        ${userInformation?.nom} ${userInformation?.prenom},
        ${Math.round(userInformation?.AGEPATIENT) > 1
        ? `${Math.round(userInformation?.AGEPATIENT)} ans`
        : `${Math.round(userInformation?.AGEPATIENT * 12)} mois`
      }
        .
        Je te réadresse ton patient.
      </div>`;
  } else {
    contentHtml5 = `<p>
        Je vous adresse ${userInformation?.civilite} ${userInformation?.nom} 
        ${userInformation?.prenom},
        ${Math.round(userInformation?.AGEPATIENT) > 1
        ? `${Math.round(userInformation?.AGEPATIENT)} ans`
        : `${Math.round(userInformation?.AGEPATIENT * 12)} mois`
      }
        .
      </p>`;
  }

  let contentHtml4 = `<h4 style="text-align: center;">${date_courrier_Long}</h4>`;
  let dataToSeeFinal;
  if (dataToSee) {
    dataToSeeFinal = contentHtml4 + contentHtml3 + contentHtml5 + dataToSee;
  } else {
    dataToSeeFinal = contentHtml4 + contentHtml3 + contentHtml5;
  }

  let Contents = (
    <div>
      <Editor
        // apiKey="4wmks1hxrd175lnu674946w8nb95pzv263exeq2v73z02al0"
        tinymceScriptSrc={process.env.PUBLIC_URL + "/tinymce/tinymce.min.js"}
        onInit={(evt, editor) => (editorRef.current = editor)}
        initialValue={dataToSeeFinal}
        init={{
          // selector: "textarea",
          branding: false,
          height: "81.5vh",
          menubar: false,
          plugins: [
            "advlist autolink lists link image charmap print preview anchor",
            "searchreplace visualblocks code fullscreen",
            "insertdatetime media table paste code help ",
            "print",
          ],
          toolbar:
            "undo redo | formatselect | " +
            "bold italic underline print forecolor backcolor | alignleft aligncenter " +
            "alignright alignjustify | bullist numlist outdent indent | ",
          content_style:

            "@page { size: A4;margin-top: 3.8cm; margin-bottom: 2.6cm; margin-left:0.5cm; margin-right:0.5cm;} body{font-size:16px} ",
        }}
      />
    </div>
  );

  return (
    <>
      <Popup
        content="Courrier"
        trigger={
          <Button

            color="yellow"
            onClick={() => dispatch({ type: ACTION.OPEN, size: "fullscreen" })}
          >
            <Icon
              color="black"
              name="envelope"
              size="large"
              className="centerIcon"
            />
          </Button>
        }
      />

      <Modal
        size={state.size}
        open={state.open}
        onClose={() => dispatch({ type: ACTION.CLOSE })}
        className="lunettesModal2"
      >
        <Modal.Header className="center3columnheaders">
          <Checkbox
            toggle
            className="checkboxFloatedLeft"
            onClick={handleClick}
            defaultChecked={checked}
            label="Je réadresse un patient"
          />
          <Checkbox
            toggle
            className="checkboxFloatedLeft"
            onClick={handleClickAmi}
            defaultChecked={ami}
            label="Cher Ami(e)"
          />
          Editeur de courriers

        </Modal.Header>
        <Modal.Content>
          <Grid>
            <Grid.Column width={8}>{Contents}</Grid.Column>

            <Grid.Column width={8}>
              <div
                id="myGrid"
                // className="ag-theme-alpine"
                className="ag-theme-balham"
                style={{
                  height: "20vh",
                  width: "100%",
                }}
              >
                <AgGridReact
                  rowData={state.rowData2 ? state.rowData2 : []}
                  // rowData={[]}
                  animateRows={true}
                  sortingOrder={["desc", "asc", null]}
                  onGridReady={onGridReady}
                  columnDefs={columnDefs2}
                  defaultColDef={defaultColDef2}
                  rowSelection={"multiple"}
                  onSelectionChanged={onSelectionChanged2}
                  undoRedoCellEditing={true}
                  undoRedoCellEditingLimit={40}
                  onCellValueChanged={onCellValueChanged2}
                ></AgGridReact>
              </div>
              <br />
              {/* <Grid.Row> */}
              {/* consultationData */}
              <div
                id="myGrid"
                className="ag-theme-balham"
                // className="ag-theme-alpine"
                style={{
                  height: "60vh",
                  width: "100%",
                  paddingTop: "0.2rem",
                  paddingBottom: "0.2rem",
                }}
              >
                <AgGridReact
                  rowData={state.rowData ? state.rowData : []}
                  animateRows={true}
                  sortingOrder={["desc", "asc", null]}
                  onGridReady={onGridReady}
                  columnDefs={columnDefsConsultation}
                  defaultColDef={defaultColDefConsultation}
                  rowSelection={"multiple"}
                  onSelectionChanged={onSelectionChangedConsul}
                  undoRedoCellEditing={true}
                  undoRedoCellEditingLimit={40}
                  onCellValueChanged={onCellValueChangedConsul}
                ></AgGridReact>
              </div>
            </Grid.Column>
          </Grid>
        </Modal.Content>
        <Modal.Actions>
          <Button
            floated="right"
            color="blue"
            onClick={() => dispatch({ type: ACTION.CLOSE })}
          >
            Retour <Icon className="leftSpace" name="reply" />
          </Button>
          <Button floated="right" positive onClick={onValueChanged}>
            Sauvegarder et retour
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  );
}

export default Medicaments;
